import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "service-date-error-container flex"
}
const _hoisted_2 = { class: "px-1 text-base" }
const _hoisted_3 = { class: "mt-1" }
const _hoisted_4 = { class: "attendee-error-list list-disc" }
const _hoisted_5 = ["textContent"]

import { computed, onMounted, toRefs } from 'vue';
import useVuelidate from '@vuelidate/core';
import { RRule } from 'rrule';

import { AttendeeDropdownOptionInterface, ExtendedDisciplineInterface } from '@/types';
import { useDateTime } from '@/composables';

interface Props {
  rrule: Partial<RRule>;
  scope: string;
  attendees: AttendeeDropdownOptionInterface[];
  vuelidateKey: string;
  disciplineId: number | undefined;
  eventType: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceDateError',
  props: {
    rrule: {},
    scope: {},
    attendees: {},
    vuelidateKey: {},
    disciplineId: {},
    eventType: {}
  },
  setup(__props: any) {

const props = __props;
const { rrule, scope, attendees, disciplineId, vuelidateKey, eventType } = toRefs(props);
const showError = computed<boolean>(() => !!v$.value.$errors.length);

// returns an array filled with the id of attendees who do not have a valid treatment service dates
const attendeeTreatmentServiceCheckArray = computed<number[]>(() => {
  const invalidArray = attendees.value.map((attendee) => {
    const attendeeId = attendee.value;
    const validTreatments = attendee.disciplines.filter((discipline) => {
      const matchingTreatments = matchingTreatmentServiceFilter(discipline);
      const validServiceDates = validDateFilter(discipline);

      return matchingTreatments && validServiceDates;
    });

    return !validTreatments.length ? attendeeId : 0;
  });

  return invalidArray.filter((number: number) => number > 0);
});

onMounted(() => {
  v$.value.rrule.options.dtstart.$touch();
  v$.value.rrule.options.until.$touch();
});

const betweenCustom = () => {
  return !attendeeTreatmentServiceCheckArray.value.length;
};

const rules = computed(() => ({
  rrule: {
    options: {
      dtstart: { betweenCustom },
      until: { betweenCustom },
    },
  },
}));

const v$ = useVuelidate(rules, { rrule }, { $scope: scope.value, $registerAs: vuelidateKey.value });

const matchingTreatmentServiceFilter = (discipline: ExtendedDisciplineInterface) =>
  discipline.id === disciplineId.value && discipline?.service?.name === eventType.value;

const validDateFilter = (discipline: ExtendedDisciplineInterface) => {
  const start = rrule.value.options?.dtstart;
  const end = rrule.value.options?.until;

  if (!start || !end) return false;

  return (
    new Date(discipline?.end_at as string).valueOf() >= start.valueOf() &&
    new Date(discipline?.end_at as string).valueOf() >= end.valueOf() &&
    new Date(discipline?.start_at as string).valueOf() <= start.valueOf() &&
    new Date(discipline?.start_at as string).valueOf() <= end.valueOf()
  );
};

const outOfServiceDateAttendeeStrings = computed<string[]>(() => {
  if (!showError.value) return [];
  const attendeeDisciplineDateStrings: string[] = [];
  attendeeTreatmentServiceCheckArray.value.forEach((invalidAttendeeId) => {
    const invalidAttendee = attendees.value.find((attendee) => attendee.value == invalidAttendeeId);
    if (invalidAttendee) {
      const invalidDisciplines = invalidAttendee?.disciplines.filter((discipline) => {
        return matchingTreatmentServiceFilter(discipline) && !validDateFilter(discipline);
      });
      if (invalidDisciplines.length) {
        invalidDisciplines.forEach((invalidDiscipline) => {
          const sixMonthsAgo = new Date();
          sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

          const startAt = new Date(invalidDiscipline.start_at);
          const endAt = new Date(invalidDiscipline.end_at);
          // if the service ended more than 6 months ago, it does not need to be listed
          if (endAt <= sixMonthsAgo) return;
          const errorString = `${invalidAttendee.name}, ${invalidDiscipline.name} ${
            invalidDiscipline?.service?.name
          } ${useDateTime().formatIntlDate(startAt.toDateString())} - ${useDateTime().formatIntlDate(
            endAt.toDateString(),
          )}`;

          attendeeDisciplineDateStrings.push(errorString);
        });
      }
    }
  });
  return attendeeDisciplineDateStrings;
});

return (_ctx: any,_cache: any) => {
  const _component_Message = _resolveComponent("Message")!

  return (showError.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Message, {
          class: "w-full",
          severity: "warn",
          closable: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "font-semibold font-sm text-color-red-dark" }, " Event dates fall outside a selected student's service dates ", -1)),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("ul", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(outOfServiceDateAttendeeStrings.value, (errorString, key) => {
                    return (_openBlock(), _createElementBlock("li", { key: key }, [
                      _createElementVNode("span", {
                        class: "text-xs text-color-orange-dark",
                        textContent: _toDisplayString(errorString)
                      }, null, 8, _hoisted_5)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})